import { FormItem } from '../../../../../components/FormItem';
import { FieldReEditHint } from './FieldReEditHint';

/** 开户表单 FormItem：退回字段下方展示红色「请修改」；required 仅用于校验，不展示红星 */
export const OpenFormItem = (props) => (
  // label 必须是 string：cdui Form.replaceError 在非 string 时会读 .textContent，undefined 会直接抛错
  <FormItem {...props} label={props.label ?? ''} class={`open-form-item ${props.class ?? ''}`.trim()}>
    {props.children}
    <FieldReEditHint field={props.field} errorField={props.errorField} />
  </FormItem>
);
